<script lang="ts">
	import VelatlasLogo from '$lib/assets/logo/velatlas-logo.svg';
	import { UrlUtil, type NavLink } from '$lib/utils/url.util';
</script>

<footer
	class="mt-5 footer grid grid-cols-2 bg-base-200 p-10 text-base-content sm:footer-horizontal sm:grid-flow-col sm:grid-cols-none sm:justify-between md:mt-10"
>
	<aside class="col-span-2 sm:col-span-1">
		<div class="flex w-full flex-row items-center justify-center">
			<img class="h-18 w-14" height="18" width="14" src={VelatlasLogo} alt="Velatlas Logo" />
			<a class="ml-4 link text-3xl font-bold link-hover" href="/">Velatlas</a>
		</div>
		<p>Copyright © {new Date().getFullYear()} - All right reserved</p>
	</aside>
	<nav>
		<p class="font-title font-bold text-base-content/70">EXPLORE</p>
		{const exploreLinks = [
			{ nav: UrlUtil.toCountries(), text: 'Countries' },
			{ nav: UrlUtil.toCities(), text: 'Cities' },
			{ nav: UrlUtil.toAtlas(), text: 'Atlas' },
			{ nav: UrlUtil.toSearch(), text: 'Search' }
		]}
		{@render Links(exploreLinks)}
	</nav>
	<nav>
		<p class="font-title font-bold text-base-content/70">COMPANY</p>
		{const companyLinks = [{ nav: UrlUtil.toAbout(), text: 'About us' }]}
		{@render Links(companyLinks)}
	</nav>
	<nav>
		<p class="font-title font-bold text-base-content/70">LEGAL</p>
		{const legalLinks = [
			{ nav: UrlUtil.toTermsOfUse(), text: 'Terms of use' },
			{ nav: UrlUtil.toPrivacyPolicy(), text: 'Privacy policy' }
		]}
		{@render Links(legalLinks)}
	</nav>
</footer>

{#snippet Links(items: { nav: NavLink; text: string }[])}
	{#each items as item (item.nav.href)}
		<a
			class="link link-hover"
			href="/{item.nav.href}"
			data-sveltekit-preload-data={item.nav.preloadData}
			data-sveltekit-preload-code={item.nav.preloadCode}
		>
			{item.text}
		</a>
	{/each}
{/snippet}
